import { Card, Flex, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"

import Icon from "../../../Icon"

import s from "./PerkCard.module.less"

const { Text } = Typography

const ComingSoonCard = () => {
  const { t } = useTranslation()

  return (
    <Card className={cls(s.card, s.cardSoon)} bordered={false} data-testid="perk-card-coming-soon">
      <Flex vertical align="center" justify="center" gap={12} className={s.soonContent}>
        <span className={s.soonIcon}>
          <Icon type="hour_glass_gray" />
        </span>
        <Text className={s.soonTitle}>{t("Coming soon")}</Text>
        <Text type="secondary" className={s.soonSub}>
          {t("A new perk is on the way.")}
        </Text>
      </Flex>
    </Card>
  )
}

export default ComingSoonCard
